export default __webpack_public_path__ + "static/media/open.4aaa4855.svg";